
import React , {useEffect, useState } from 'react'; 
import {GridWrap, ListWrap, Elements} from "./helpers" 
import app from "./app"
 


export const MapOne = function({data, index, widgetType, mode, device}) { 
  // console.log("MapOne", data)   
    // const domEle = useRef();
    // useEffect(() => { 
    //     if(app.getMode(mode) && window.data && window.data.googlePlacesApiKey){
    //         setTimeout(function(){ 
    //             loadedMap(data.elements.maps, window.data.googlePlacesApiKey);
    //         },3000)
    //     } 
    // }, []);
    const [isWindowAvailable, setIsWindowAvailable] = useState(false);
    useEffect(() => { 
        if (typeof window !== 'undefined') {
            setIsWindowAvailable(true);  // Set the state to true when window is available
        }
        if(app.getMode(mode) && isWindowAvailable && window.data && window.data.googlePlacesApiKey){
            setTimeout(function(){ 
                loadedMap(data.elements.maps, window.data.googlePlacesApiKey);
            },3000)
        } 
    }, [data]); 


    const loadMap = function(key, callback) {
        if (key) {
            if (document.querySelector("#gMap")) {
                console.log("Alerady Google Maps script loaded successfully");
                callback();
            } else {
                app.loadScript(`https://maps.googleapis.com/maps/api/js?v=3.exp&sensor=true&libraries=places&key=${key}`, "gMap").then(function () {
                    console.log("Google Maps script loaded successfully");
                    callback();
                });
            }
        }
    }; 

    const loadedMap = function(maps, googlePlacesApiKey){ 
        let map, bounds, infoWindowContent = [], geocoder;
        let elementId = "services-map-"+index;
        if(maps.items) { 
            if(maps.items.length) { 
                if(document.getElementById(elementId)){
                    loadMap(googlePlacesApiKey, function(row){ 
                        infoWindowContent = []; 
                        geocoder = new window.google.maps.Geocoder();
                        bounds = new window.google.maps.LatLngBounds(); 
                        map = new window.google.maps.Map(document.getElementById(elementId), {
                            mapTypeId: 'roadmap'
                        });
                        map.setTilt(45);
                       
    
                    maps.items.forEach(function(v, i){  
                        if (v.summary.text) {
                            if(geocoder){
                                geocoder.geocode({ 'address': v.summary.text }, function (results, status) {
                                    if (status === window.google.maps.GeocoderStatus.OK) {
                                        const location = results[0].geometry.location;
                                        const latitude = location.lat();
                                        const longitude = location.lng();
                                        
                                        let text = '<div class="info_content" style="cursor: pointer" date-index='+i+'><h6>'+ v.summary.text +' </h6></div>';
                                        infoWindowContent.push(new window.google.maps.InfoWindow()); 
                                        let position = new window.google.maps.LatLng(latitude, longitude);
                                        let marker = new window.google.maps.Marker({
                                            position: position,
                                            map: map,
                                            title: v.header
                                        });
                                        bounds.extend(position); 
                                        window.google.maps.event.addListener(marker, 'click', (function(marker, i) {
                                            return function() {
                                                infoWindowContent[i].setContent(text);
                                                infoWindowContent[i].open(map, marker);  
                                            }
                                        })(marker, i)); 
         
                                        document.querySelectorAll(".hideMap-col .click_map")[i].addEventListener("click", function(){ 
                                            infoWindowContent.forEach(function(v){
                                                v.close();
                                            })
                                            document.querySelectorAll(".hideMap-col .click_map").forEach(function(v){
                                                if(v.classList.contains("active")){
                                                    v.classList.remove("active")
                                                } 
                                            })
                                            window.google.maps.event.trigger(marker,'click');
                                            if(document.querySelectorAll(".hideMap-col .click_map")[i]){
                                                document.querySelectorAll(".hideMap-col .click_map")[i].classList.add("active")
                                            } 
                                        }) 
                                        map.fitBounds(bounds); 
                                    } else {
                                        console.error('Geocoding failed with status:', status);
                                    }
                                });
                            } 
                        } 
     
                    })
    
                
                    var boundsListener = window.google.maps.event.addListener((map), 'bounds_changed', function(event) {
                        this.setZoom(map.getZoom()-1); 
                        if (this.getZoom() > 15) {
                            this.setZoom(15);
                        }
                        window.google.maps.event.removeListener(boundsListener);
                    });
                    })
                } 
            }
        }
    }


    let listitem = "" 
    let isMap = false;
    if(data.elements.maps){ 
         if(data.elements.maps.items){   
            listitem = data.elements.maps.items.map(function(v, i){  
                if(v.summary.properties.isMap){
                    isMap = true
                }
                return <GridWrap className="" data={v} key={'key-' + v.viewId + i} id="maps" mode={mode} device={device}>
                    <div className='d-flex'>
                    <div className="float-start w-75 click_map">
                        <Elements row={v.icon} id={"icon"} classType="float-start" device={device} />
                        <div className='overflow-hidden'>
                            <Elements row={v.heading} id={"heading"} device={device} /> 
                            <Elements row={v.summary} id={"summary"} device={device} classType="hideAi"/>
                        </div> 
                    </div> 

                    {app.getMode(mode)?
                    <div className="map-action d-flex ms-auto ps-2 float-end"> 
                        <div className={app.getHide(v.share)}  onClick={()=> app.shareContent(v.heading.text, v.summary.text, "url")} style={{cursor:'pointer'}}>
                            <Elements row={v.share} id={"share"} device={device} />
                        </div>
                        <a className={app.getHide(v.direction)} href={`https://maps.google.com/maps?q=${encodeURIComponent(v.summary.text)}`} target='_blank' style={{textDecoration:'none'}}>
                            <Elements row={v.direction} id={"direction"} classType="ms-2" device={device} />
                        </a> 
                    </div>
                    :
                    <div className="map-action d-flex ms-auto ps-2 float-end"> 
                        <Elements row={v.share} id={"share"} device={device} mode={mode} />
                        <Elements row={v.direction} id={"direction"} classType="ms-2" device={device} mode={mode} />
                    </div>
                    }

                    </div>
                    
                    <div>
                        <Elements row={v.summary} id={"summary"} device={device} mode={mode} map={true}  classType="hideAi"/>
                    </div>
                </GridWrap> 
            }) 
        }
        if(isMap && device == "desktop"){ 
            listitem = <ListWrap data={data.elements.maps} mode={mode} device={device} className="row" grid={false} index={index}>
                <div className="col hideMap-col">
                        {listitem}
                    </div>
                    {app.getMode(mode) && isWindowAvailable && window.data && window.data.googlePlacesApiKey?
                        <div className="col-7" id={`services-map-${index}`} style={{minHeight:'400px'}}></div>
                        :
                        <div className="col-7">
                            <img width="100%" src="https://mediadirhub.com/samples/map.png"/>
                        </div>
                    }
            </ListWrap>
        }else{
            listitem = <ListWrap data={data.elements.maps} mode={mode} device={device} className="row g-4 align-items-start justify-content-start row-cols-1 row-cols-lg-2" index={index}>
                {listitem}
            </ListWrap>
        }
       
    }

return  <div className="container-fluid p-0 position-relative"> 
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />  
            </div>
        </div>

        {listitem} 
    </div>
}

 
 